import { render } from "./StartingSpace.vue?vue&type=template&id=26377fc7&scoped=true"
import script from "./StartingSpace.vue?vue&type=script&lang=js"
export * from "./StartingSpace.vue?vue&type=script&lang=js"

import "./StartingSpace.vue?vue&type=style&index=0&id=26377fc7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26377fc7"]])

export default __exports__